<template>
  <b-nav
    pills
    class="align-items-center builder-nav-font-size"
  >
    <BuilderNavMenu class="flex-grow-1" />
    <BuilderNavWizard
      v-if="showWizard"
      v-bind="commonProps"
    />
    <BuilderNavSave v-bind="commonProps" />
    <BuilderNavPublish v-bind="commonProps" />
  </b-nav>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderNavMenu from '@/components/builder/BuilderNav/BuilderNavMenu.vue'
import BuilderNavSave from '@/components/builder/BuilderNav/BuilderNavSave.vue'
import BuilderNavPublish from '@/components/builder/BuilderNav/BuilderNavPublish.vue'
import BuilderNavWizard from '@/components/builder/BuilderNav/BuilderNavWizard.vue'
import { ButtonStates } from '@/types'

const components = {
  BuilderNavMenu,
  BuilderNavSave,
  BuilderNavPublish,
  BuilderNavWizard,
}

@Component({ components })
export default class BuilderNav extends Vue {
  iconSize = 'lg'
  saveState = ButtonStates.ICON
  publishState = ButtonStates.ICON

  get showWizard () {
    return !this.$typedStore.primary.app.isConsolidatedApp
  }

  get imageUploading () {
    return this.$typedStore.primary.entities.images.imageUploading
  }

  get commonProps () {
    return {
      disabled: this.imageUploading,
      iconSize: this.iconSize,
    }
  }
}

</script>

<style>

/* NB unscoped so that dropdown can use the same font size */
.builder-nav-font-size {
  font-size: 1.15rem;
}

</style>
